import { apiClient } from '../../../../api/axios';
import type { ApiResponse, Cycle, CycleEvent, EventType } from '../common/types';

export const cycleService = {
    getAllCycles: async (status: boolean = true): Promise<ApiResponse<Cycle[]>> => {
        const response = await apiClient.get(`/Cycles/GetAllCycle?status=${status}`);
        return response.data;
    },

    createCycle: async (name: string, tag: string): Promise<ApiResponse<Cycle>> => {
        const payload = {
            id: 0,
            name,
            tag,
            active: true,
        };
        const response = await apiClient.post('/Cycles/CreateCycle', payload);
        return response.data;
    },

    updateCycle: async (cycle: Cycle): Promise<ApiResponse<Cycle>> => {
        const response = await apiClient.post('/Cycles/UpdateCycle', cycle);
        return response.data;
    },

    deleteCycle: async (id: number): Promise<ApiResponse<void>> => {
        const response = await apiClient.post(`/Cycles/DeleteCycle?id=${id}`);
        return response.data;
    },

    enableCycleForActivities: async (cycleId: number): Promise<ApiResponse<any>> => {
        const response = await apiClient.get(`/Cycles/EnableCycleForActivities?cycleId=${cycleId}`);
        return response.data;
    },

    getRunningCycle: async (): Promise<ApiResponse<Cycle>> => {
        const response = await apiClient.get('/Cycles/GetRunningCycle');
        return response.data;
    },
};

export const eventCycleService = {
    getActiveCycleEvent: async (): Promise<ApiResponse<CycleEvent>> => {
        const response = await apiClient.get('/EventCycles/GetActiveCycleEvent');
        return response.data;
    },

    getAllEventCycles: async (cycleId: number, status?: boolean): Promise<ApiResponse<CycleEvent[]>> => {
        let url = `/EventCycles/GetAll?cycleId=${cycleId}`;
        if (status !== undefined) url += `&status=${status}`;
        const response = await apiClient.get(url);
        return response.data;
    },

    createEventCycle: async (payload: { id: number; eventTypeId: number; cycleId: number; startDate: string; endDate: string }): Promise<ApiResponse<CycleEvent>> => {
        const response = await apiClient.post('/EventCycles/Create', payload);
        return response.data;
    },

    updateEventCycle: async (payload: { id: number; eventTypeId: number; cycleId: number; startDate: string; endDate: string }): Promise<ApiResponse<CycleEvent>> => {
        const response = await apiClient.post('/EventCycles/Update', payload);
        return response.data;
    },

    activateEventCycle: async (id: number, status: boolean): Promise<ApiResponse<void>> => {
        const response = await apiClient.post(`/EventCycles/Activate?id=${id}&status=${status}`);
        return response.data;
    },

    deleteEventCycle: async (id: number): Promise<ApiResponse<void>> => {
        const response = await apiClient.post(`/EventCycles/Delete?id=${id}`);
        return response.data;
    },

    getAllEventTypes: async (status: boolean = true): Promise<ApiResponse<EventType[]>> => {
        const response = await apiClient.get(`/EventCycles/GetAllEventType?status=${status}`);
        return response.data;
    },
};
